module.exports = __webpack_public_path__ + "images/528a531f9413ef9bd65942409a3848e8.png";